import styles from './ControlledScrollModule.scss';

import cx from 'classnames';
import { Entry } from 'contentful';
import React from 'react';

import { ControlledScrollAssembly } from 'src/api/contentful/contentTypes.cloverdotcom';
import { Text } from '../Contentful/Text';
import { ScrollWrapperContainer } from './ScrollWrapper/ScrollWrapper';

export interface IControlledScrollModule extends React.AllHTMLAttributes<HTMLElement> {
  entry?: Entry<ControlledScrollAssembly>;
}

export class ControlledScrollModule extends React.PureComponent<IControlledScrollModule> {

  render() {
    const { entry, className, ...props } = this.props;

    if (!entry || !entry.fields) return null;

    const { items, backgroundColor } = entry.fields;

    return (
      <section className={cx(styles.controlledScrollWrapper, className)} {...props}>
        <Text tagName="h2" entry={entry} field="title" className={styles.controlledScroll} />
        <ScrollWrapperContainer entries={items} backgroundColor={backgroundColor} />
      </section>
    );
  }

}
